export default __webpack_public_path__ + "images/CH.4e9543b.png";